/* eslint-disable max-len */
import PropTypes from 'prop-types'
import { PropTypes as MobXPropTypes } from 'mobx-react'
import React from 'react'

import FormSection from '../../shared/components/FormSection'
import FormGroup from '../../shared/components/FormGroup'
import TextArea from '../../shared/components/TextArea'
import TextInput from '../../shared/components/TextInput'
import ValidationText from '../../shared/components/ValidationText'
import ValidationInfo from '../../shared/components/ValidationInfo'
import AttributedListInput from '../../shared/components/AttributedListInput'
import MonthSelect from '../../shared/components/MonthSelect'

import { formatNumber, isNotEmpty } from '../../shared/utils'

const BookingFormSection = ({
  validationObj,
  days,
  bookingStart,
  bookingEnd,
  // bookableOutOfSeason,
  bookableOutOfOpeningTimes,
  temporarilyNotBookable,
  temporarilyNotBookableReason,
  specialConditionsForRemedialClasses,
  freeEntryForTeachersAtPrevisit,
  generalPrice,
  minPrice,
  costsByPerson,
  onChange,
  readOnly,
  show,
  fieldSpecs
}) => {

  // const hasMinPrice = isNotEmpty(minPrice)
  const hasGeneralPrice = isNotEmpty(generalPrice)
  const hasCostsByPerson = isNotEmpty(costsByPerson)

  return (
    <FormSection
      title="3. Buchung &amp; Kosten"
      show={show}
    >
      <FormGroup
        label={fieldSpecs.bookingStart.label}
        info={fieldSpecs.bookingStart.info}
        note={fieldSpecs.bookingStart.note}
        name="booking-start"
        onChange={onChange}
        classNames="group-helper"
      >

        <div className="col-xs-3 col-lg-3">

          {/*
        <input
          id="booking-start"
          className="form-control"
          name="bookingStart"
          value={bookingStart}
          disabled={readOnly}

          type={fieldSpecs.bookingStart.type}
          required={fieldSpecs.bookingStart.required}
        />
        */}

          <MonthSelect
            id="booking-start"
            className="form-control"
            name="bookingStart"
            disabled={readOnly}
            required={fieldSpecs.bookingStart.required}
            value={bookingStart}
            start
            onChange={onChange}
          />
          <ValidationText isValid={validationObj.bookingStart}>
            <ValidationInfo isValid={validationObj.bookingStart} />
          </ValidationText>
        </div>

        <div className="col-xs-1 col-lg-1">
          <label htmlFor="booking-end">{fieldSpecs.bookingEnd.label}</label>
        </div>
        <div className="col-xs-3 col-lg-3">

          {/*
        <input
          id="booking-end"
          className="form-control"
          name="bookingEnd"
          value={bookingEnd}
          disabled={readOnly}

          type={fieldSpecs.bookingStart.type}
          required={fieldSpecs.bookingStart.required}
        />
        */}

          <MonthSelect
            id="booking-end"
            className="form-control"
            name="bookingEnd"
            disabled={readOnly}
            required={fieldSpecs.bookingEnd.required}
            value={bookingEnd}
            end
            onChange={onChange}
          />
          <ValidationText isValid={validationObj.bookingEnd}>
            <ValidationInfo isValid={validationObj.bookingEnd} />
          </ValidationText>
        </div>

      </FormGroup>

      {/*<div
      className="form-group"
      onChange={onChange}
    >
      <div className="col-xs-8 col-xs-offset-4">
        <div className="checkbox">
          <label
            htmlFor="bookable-out-of-season"
          >
            <input
              type="checkbox"
              className="form-control"
              id="bookable-out-of-season"
              name="bookableOutOfOpeningTimes"
              checked={bookableOutOfOpeningTimes}
              disabled={readOnly}
            />
            <span>{fieldSpecs.bookableOutOfOpeningTimes.label}</span>
          </label>
        </div>
      </div>
    </div>*/}

      <div
        className="form-group"
        onChange={onChange}
      >
        <div className="col-xs-8 col-xs-offset-4">
          <div className="checkbox">
            <label
              htmlFor="bookable-out-of-opening-times"
            >
              <input
                type="checkbox"
                className="form-control"
                id="bookable-out-of-opening-times"
                name="bookableOutOfOpeningTimes"
                checked={bookableOutOfOpeningTimes}
                disabled={readOnly}
              />
              <span>{fieldSpecs.bookableOutOfOpeningTimes.label}</span>
            </label>
          </div>
        </div>
      </div>

      <AttributedListInput
        name="days"
        placeholder="Anzahl"
        list={window.APP_CONFIG.list_day}
        value={days.toJS ? days.toJS() : days}
        onChange={onChange}
        isValid={validationObj.days}
        hideAttribute
        columns={2}
        disabled={readOnly}
        {...fieldSpecs.days}
      />

      <div className="warn-block">
        Aktivieren Sie folgende Checkbox, sofern die Führung zur Zeit nicht buchbar ist (z.B. coronabedingt). Die Führung bleibt dann weiterhin auf der Website sichtbar, wird aber als &ldquo;temporär nicht buchbar&rdquo; dargestellt.
      </div>

      <div
        className="form-group"
        onChange={onChange}
      >
        <div className="col-xs-8">
          <div className="checkbox">
            <label
              htmlFor="temporarily-not-bookable"
            >
              <input
                type="checkbox"
                className="form-control"
                name="temporarilyNotBookable"
                id="temporarily-not-bookable"
                checked={temporarilyNotBookable}
                disabled={readOnly}
              />
              <span>
                {fieldSpecs.temporarilyNotBookable.label}
              </span>
            </label>
          </div>
        </div>
      </div>

      <TextArea
        value={temporarilyNotBookableReason}
        name="temporarilyNotBookableReason"
        // helpText="Bitte den Lehrplanbezug mit Komma getrennt auflisten"
        onChange={onChange}
        // atm. always disabled, Text is set by system
        disabled={readOnly || true}
        {...fieldSpecs.temporarilyNotBookableReason}
      />

      <h3>Kosten</h3>

      <TextInput
        withEnabler
        name="generalPrice"
        value={generalPrice}
        isValid={validationObj.generalPrice}
        disabled={readOnly || hasCostsByPerson}
        onChange={onChange}
        group={{ after: '€' }}
        size={3}
        step="0.05"
        formatter={formatNumber}
        {...fieldSpecs.generalPrice}
      />

      <TextInput
        withEnabler
        name="costsByPerson"
        value={costsByPerson}
        isValid={validationObj.costsByPerson}
        disabled={readOnly || hasGeneralPrice}
        onChange={onChange}
        group={{ after: '€' }}
        size={3}
        step="0.05"
        formatter={formatNumber}
        {...fieldSpecs.costsByPerson}
      />

      <TextInput
        withEnabler
        name="minPrice"
        value={minPrice}
        isValid={validationObj.minPrice}
        disabled={readOnly || hasGeneralPrice || !hasCostsByPerson}
        onChange={onChange}
        group={{ after: '€' }}
        size={3}
        step="0.05"
        formatter={formatNumber}
        {...fieldSpecs.minPrice}
      />

      <div
        className="form-group"
        onChange={onChange}
      >
        <div className="col-xs-8 col-xs-offset-4">
          <div className="checkbox">
            <label
              htmlFor="special-conditions-for-remedial-classes"
            >
              <input
                type="checkbox"
                className="form-control"
                name="specialConditionsForRemedialClasses"
                id="special-conditions-for-remedial-classes"
                checked={specialConditionsForRemedialClasses}
                disabled={readOnly}
              />
              <span>
                {fieldSpecs.specialConditionsForRemedialClasses.label}
              </span>
            </label>
          </div>
        </div>
      </div>

      <div
        className="form-group"
        onChange={onChange}
      >
        <div className="col-xs-8 col-xs-offset-4">
          <div className="checkbox">
            <label
              htmlFor="free-entry-for-teachers-at-previsit"
            >
              <input
                type="checkbox"
                className="form-control"
                name="freeEntryForTeachersAtPrevisit"
                id="free-entry-for-teachers-at-previsit"
                checked={freeEntryForTeachersAtPrevisit}
                disabled={readOnly}
              />
              <span>
                {fieldSpecs.freeEntryForTeachersAtPrevisit.label}
              </span>
            </label>
          </div>
        </div>
      </div>

    </FormSection>
  )
}

BookingFormSection.propTypes = {
  bookableOutOfOpeningTimes: PropTypes.bool,
  bookableOutOfSeason: PropTypes.bool,
  bookingEnd: PropTypes.string,
  bookingStart: PropTypes.string,
  costsByPerson: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  days: MobXPropTypes.observableArray,
  fieldSpecs: PropTypes.object.isRequired,
  freeEntryForTeachersAtPrevisit: PropTypes.bool,
  generalPrice: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  materialCosts: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  minPrice: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  show: PropTypes.bool,
  specialConditionsForRemedialClasses: PropTypes.bool,
  temporarilyNotBookable: PropTypes.bool,
  temporarilyNotBookableReason: PropTypes.string,
  validationObj: PropTypes.object,

}

export { BookingFormSection as default }



// WEBPACK FOOTER //
// ./src/guided-tour/components/03-BookingFormSection.js